export const isDevelopmentEnv = () => environment.env == "Development";

export const isProductionEnv = () => environment.env == "Production";
